<template>
  <div class="wg-attachments">
    <div class="wg-head">
      <h4>ATTACHMENTS</h4>
      <a href="javascript:;" class="btn btn-outline-gray">+</a>
    </div>
    <div class="wg-body">
      <ul>
        <li><a href="" target="_blank">Document name here.pdf</a></li>
        <li><a href="" target="_blank">Another document here.csv</a></li>
        <li><a href="" target="_blank">The longest document name here.doc</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  watch: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    init () {

    }
  }
}
</script>
